import gql from 'graphql-tag';
import { blogArticleFragment } from '../fragments';
export const getArticleByIdQuery = gql `
  query GetArticleById($record: GetArticleByIdRecord!) {
    getArticleById(record: $record) {
      ...articleFields
      category {
        id
        translations {
          id
          name
          language {
            name
            code
          }
        }
      }
      thumbnail
      id
      createdAt
      isFeatured
      publishDate
      readingTime
      status
      updatedAt
      translations {
        content
        headline
        id
        description
        tagWords
        language {
          code
        }
      }
    }
  }
  ${blogArticleFragment}
`;
//# sourceMappingURL=getArticleById.js.map